import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Gtp } from '../../gtp';
import { AccesosAlSistemaComponent } from 'src/app/modules/admin/accesos-al-sistema/accesos-al-sistema.component';

interface MenuItem {
  label: string;
  link?: string;
  icon?: string;
}

interface MenuSection {
  label: string;
  icon: string;
  items?: MenuItem[];
  expanded?: boolean;
  link?: string;
}

@Component({
  selector: 'app-admin-menu',
  templateUrl: './admin-menu.component.html',
  styleUrls: ['./admin-menu.component.scss']
})
export class AdminMenuComponent implements OnInit {

  configMenuSidebar = {
    fontColor: '#757575',
    classname: 'menuSidebar',
  }

  MenuSideBar: MenuSection[] = [
    {
      label: 'Administración',
      icon: 'admin_panel_settings',
      expanded: false,
      items: [
        {
          label: 'Mi Cuenta',
          link: '/admin/cuenta',
          icon: 'account_circle'
        },
        {
          label: 'Control Vehículos Notificaciones',
          link: '/admin/control-vehiculos',
          icon: 'directions_car'
        },
        {
          label: 'Usuarios',
          link: '/admin/usuarios',
          icon: 'group'
        },
        {
          label: 'Grupos',
          link: '/admin/grupos',
          icon: 'device_hub'
        },
        {
          label: 'Accesos al Sistema',
          link: '/admin/accesos-al-sistema',
          icon: 'shield'
        }
      ]
    },
    {
      label: 'Herramientas',
      icon: 'build',
      expanded: false,
      items: [
        {
          label: 'Grupos De Referencias',
          link: '/admin/grupos-referencia',
          icon: 'device_hub'
        },
        {
          label: 'Importar Puntos',
          link: '/admin/importar-puntos',
          icon: 'upload_file'
        }
      ]
    },
    {
      label: 'Ayuda',
      icon: 'help_outline',
      expanded: false,
      items: [
        {
          label: 'Actualizaciones',
          link: '/admin/upgrade',
          icon: 'system_update'
        },
        {
          label: 'Contactos',
          link: '/admin/contactos',
          icon: 'contact_page'
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private gtp: Gtp
  ) { }

  ngOnInit(): void {
  }

  toggleSection(section: MenuSection): void {
    if (section.items?.length) {
      section.expanded = !section.expanded;
    } else {
      this.goToPage(section);
    }
  }

  closeMenu(): void {
    this.gtp.setAdminSidebar(false);
    this.router.navigate(['/inicio/flota'])

  }

  goToPage(obj: MenuItem | MenuSection): void {
    // Para items de admin, simplemente navegamos y el sidebar izquierdo se abre automáticamente
    this.gtp.setAdminSidebar(false);
    if (obj.link) {
      // Si es accesos-al-sistema, abrimos la tabla flotante
      if (obj.link === '/admin/accesos-al-sistema') {
        this.gtp.setMainOutlet(AccesosAlSistemaComponent);
      } else {
        this.router.navigate(['/inicio/' + obj.link]);
        // Abrimos el sidebar principal para mostrar el contenido
        this.gtp.setMainSidebar(true);
      }
    }
  }
}
